// extracted by mini-css-extract-plugin
export default {"headerCl":"Header_headerCl__3H9p7","logoAndName":"Header_logoAndName__BS04y"};